var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "scrolldown"
  }, [_c('div', {
    staticClass: "scrolldown__mouse"
  }), _c('div', {
    staticClass: "scrolldown__arrow"
  }, [_c('svg', {
    staticClass: "icon-svg icon-chevron",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 10"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,8.6l0.9,0.9L8,2.3l7.1,7.2L16,8.6L8,0.5L0,8.6z"
    }
  })]), _c('svg', {
    staticClass: "icon-svg icon-chevron",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 10"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,8.6l0.9,0.9L8,2.3l7.1,7.2L16,8.6L8,0.5L0,8.6z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }